import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=408c9ee3"
import script from "./Onboarding.vue?vue&type=script&lang=js"
export * from "./Onboarding.vue?vue&type=script&lang=js"
import style0 from "./Onboarding.vue?vue&type=style&index=0&id=408c9ee3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports